import React from "react";
import Chart from "react-apexcharts";

const defData = {
  options: {
    chart: {
      type: "bar",
      height: "750px",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,

        horizontal: true,
      },
    },
    theme: {
      mode: "dark",
      monochrome: {
        enabled: false,
        color: "#68bcbc",
        shadeTo: "dark",
        shadeIntensity: 0.1,
      },
    },
    title: {
      text: "Personas por Departamento",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "rgba(250, 250, 250, 0.8)",
      },
    },
    xaxis: {
      categories: [
        1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1995, 1996, 1997, 1998,
        1995, 1996, 1997, 1998, 1995, 1996, 1997,
      ],
    },
  },
  series: [
    {
      data: [
        30, 40, 45, 50, 49, 60, 70, 91, 40, 45, 50, 49, 40, 45, 50, 49, 40, 45,
        50,
      ],
    },
  ],
};
const DeptoChart = ({ deptosList, personasList, setMarkerDataList }) => {
  const [data, setData] = React.useState(defData);
  const processDeptoData = () => {
    const formattedData = {
      ...data,
    };
    formattedData.options = {
      ...data.options,
      ...{
        xaxis: { categories: deptosList.map((item) => item.nombre) },
      },
    };
    return formattedData;
  };

  React.useEffect(() => {
    let formattedData = { ...processDeptoData() };
    const markerList = [];
    const populatedDeptos = [];
    const personPerDeptos = [];

    formattedData = {
      ...formattedData,
      ...{
        series: [
          {
            data: formattedData.options.xaxis.categories.map((deptoItem) => {
              const deptoObj = deptosList.find(
                (item) => item.nombre === deptoItem
              );
              const personPerDeptoList = personasList.filter(
                (person) => person.departamento === deptoObj.id
              );
              if(personPerDeptoList.length > 0){
                const markerData = {
                  nombre: deptoObj.nombre,
                  latitud: deptoObj.latitud,
                  longitud: deptoObj.longitud,
                  censados: personPerDeptoList.length,
                };
                personPerDeptos.push(personPerDeptoList.length)
                populatedDeptos.push(deptoObj.nombre);
                markerList.push(markerData)
              }
              return personPerDeptoList.length;
            }),
          },
        ],
      },
    };

    formattedData.options = {
      ...formattedData.options,
      ...{
        xaxis: { categories: populatedDeptos},
      },
    };
    formattedData = {
      ...formattedData,
      ...{
        series: [
          {
            data: personPerDeptos,
          },
        ],
      },
    };
    setMarkerDataList(markerList);
    setData({ ...formattedData });
    
  }, [deptosList, personasList]);

  return (
    <Chart
      className="chart"
      options={data.options}
      series={data.series}
      type="bar"
      width="100%"
      height={"100%"}
    />
  );
};
export default DeptoChart;
